import { collection, addDoc, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export class TransactionLogger {
  static async logTransaction(action, entityType, entityId, oldData, newData, userId, userEmail) {
    try {
      const transaction = {
        action, // 'CREATE', 'UPDATE', 'DELETE'
        entityType, // 'PLAYER', 'TOURNAMENT', 'MATCH', 'SCORE'
        entityId,
        oldData: oldData || null,
        newData: newData || null,
        userId,
        userEmail,
        timestamp: new Date(),
        ipAddress: null, // Could be added if needed
        userAgent: navigator.userAgent
      };

      await addDoc(collection(db, 'transactionLogs'), transaction);
      console.log(`Transaction logged: ${action} ${entityType} ${entityId}`);
    } catch (error) {
      console.error('Error logging transaction:', error);
    }
  }

  static async getTransactionLogs(limitCount = 100) {
    try {
      const q = query(
        collection(db, 'transactionLogs'),
        orderBy('timestamp', 'desc'),
        limit(limitCount)
      );
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error fetching transaction logs:', error);
      return [];
    }
  }

  static async getTransactionLogsByEntity(entityType, entityId) {
    try {
      const q = query(
        collection(db, 'transactionLogs'),
        orderBy('timestamp', 'desc')
      );
      const snapshot = await getDocs(q);
      return snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(log => log.entityType === entityType && log.entityId === entityId);
    } catch (error) {
      console.error('Error fetching entity transaction logs:', error);
      return [];
    }
  }
}

export default TransactionLogger;










